import { IUserGuide } from "./userGuideTypes";

export const USER_GUIDE_TITLE_MAX_LENGTH = 255;

export const ALLOWED_USER_GUIDE_FILE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "video/x-msvideo",
  "video/avi",
  "video/msvideo",
  "application/x-msvideo",
  "application/x-troff-msvideo",
];

export const USER_GUIDE_VIDEO_FILE_EXTENSIONS = [
  ".mp4",
  ".mpeg",
  ".mov",
  ".avi",
];

export const ACCEPTED_USER_GUIDE_FILE_EXTENSIONS =
  ".pdf,.doc,.docx,.ppt,.pptx,.mp4,.mpeg,.mov,.avi";

export const MAX_USER_GUIDE_DOCUMENT_SIZE_IN_BYTES = 20 * 1024 * 1024;
export const MAX_USER_GUIDE_VIDEO_SIZE_IN_BYTES = 95 * 1024 * 1024;

export const validateUserGuideFile = (file: File | null): string => {
  if (!file) {
    return "File is required.";
  }

  const fileExtension = `.${file.name.split(".").pop()?.toLowerCase() || ""}`;

  const isAllowedMimeType = ALLOWED_USER_GUIDE_FILE_TYPES.includes(file.type);
  const isAllowedExtension = ACCEPTED_USER_GUIDE_FILE_EXTENSIONS.split(
    ",",
  ).includes(fileExtension);

  if (!isAllowedMimeType && !isAllowedExtension) {
    return "Unsupported file type. Please upload PDF, DOC, DOCX, PPT, PPTX, MP4, MPEG, MOV, or AVI file.";
  }

  const isVideoFile =
    file.type.startsWith("video/") ||
    USER_GUIDE_VIDEO_FILE_EXTENSIONS.includes(fileExtension);

  const maxAllowedSize = isVideoFile
    ? MAX_USER_GUIDE_VIDEO_SIZE_IN_BYTES
    : MAX_USER_GUIDE_DOCUMENT_SIZE_IN_BYTES;

  if (file.size > maxAllowedSize) {
    const maxSizeInMb = maxAllowedSize / (1024 * 1024);
    return `File size should not exceed ${maxSizeInMb}MB.`;
  }

  return "";
};

export const filterUserGuides = (
  userGuides: IUserGuide[],
  searchText: string,
): IUserGuide[] => {
  const normalizedSearchText = searchText.trim().toLowerCase();

  if (!normalizedSearchText) {
    return userGuides;
  }

  return userGuides.filter((guide) => {
    const title = guide.title?.toLowerCase() || "";
    const description = guide.description?.toLowerCase() || "";

    return (
      title.includes(normalizedSearchText) ||
      description.includes(normalizedSearchText)
    );
  });
};

export const openUserGuideFile = (fileUrl: string | null): void => {
  if (!fileUrl) {
    return;
  }

  window.open(fileUrl, "_blank", "noopener,noreferrer");
};

